import { DateTime } from 'luxon'

const isMilliseconds = (number) => {
  return number > 9999999999
}
export const useDateManager = () => {
  const parseDate = (date) => {
    if (typeof date === 'string') {
      return DateTime.fromISO(date)
    }
    if (typeof date === 'number') {
      return isMilliseconds(date)
        ? DateTime.fromMillis(date)
        : DateTime.fromSeconds(date)
    }
    if (date instanceof Date) {
      return DateTime.fromJSDate(date)
    }
    if (date instanceof DateTime) {
      return date
    }

    return new Error('Invalid date')
  }
  const formatDate = (date, stringFormat = "MMMM dd, yyyy 'at' t ZZZZ") => {
    return parseDate(date).toFormat(stringFormat)
  }

  const formatRelativeDate = (date) => {
    return parseDate(date).toRelative()
  }

  const groupByDateFormat = (dates, key, format) => {
    return dates.reduce((accumulator, date) => {
      const formattedDate = formatDate(date[key], format)
      if (!accumulator[formattedDate]) {
        accumulator[formattedDate] = []
      }
      accumulator[formattedDate].push(date)
      return accumulator
    }, {})
  }

  return {
    formatDate,
    formatRelativeDate,
    groupByDateFormat,
    parseDate,
  }
}
